export const loadAdRollScript = () => {
  const script = document.createElement("script")
  script.src = "https://s.adroll.com/j/" + process.env.REACT_APP_ADROLL_ADV_ID + "/roundtrip.js"
  script.async = true
  document.body.appendChild(script)
}
